import Card from '../components/ui/Card';

export default function PagamentosConsultores() {
  return (
    <div className="px-3 sm:px-6 py-4 sm:py-5">
      <Card
        title="Pagamentos a consultores"
        subtitle="Módulo futuro para gerir pagamentos a consultores humanos."
      >
        <div className="text-center py-12 text-text-soft">
          <div className="text-[3rem] mb-2">🚧</div>
          <div className="text-[0.9rem]">Funcionalidade em desenvolvimento</div>
          <div className="text-[0.75rem] mt-1">
            Esta secção permitirá gerir comissões e pagamentos aos consultores.
          </div>
        </div>
      </Card>
    </div>
  );
}
